class ActivityTabs extends HTMLElement {
  constructor() {
      super();
      this.guid = this.getAttribute('guid');
      this.tabPanelRows = parseInt(this.getAttribute('tab-panel-rows'));
      this.data = null;
      this.tabsContent = null;
      this.tablist = this.querySelector(".tablist");
      this.tablistButtons = this.querySelectorAll(".tab-button"); 
      this.activeTabButton = this.querySelector(".tab-button[aria-selected=true]");
      this.tabsPanels = this.querySelectorAll(".tab-panel");
  }
  
  connectedCallback() {
    let that = this;
    
    this.bindEvents();
    
    this.getData().then(() => {
      that.render();
    });
    
    this.doTablistCalculations(this.activeTabButton);

    this.attacthIntersectionObserverOnTablist();

  }

  attacthIntersectionObserverOnTablist() { 
    // get the sticky element
      const stickyElm = this.querySelector(".sticky-tablist");
      const stickyElmTop = parseInt(stickyElm.getAttribute("data-top")) + 1;

      // we need to know how far down the page the sticky element is, 
      // then minus with 1px to make sure the element is not sticky when it is at the top of the page
      const observer = new IntersectionObserver(
        ([e]) => e.target.classList.toggle('is-sticky', e.intersectionRatio < 1), {
        rootMargin: `-${stickyElmTop}px 0px 0px 0px`,
        threshold: [1],
      });

      observer.observe(stickyElm);  
  }


  doTablistCalculations(button) {
    this.tablist.style.setProperty("--transformJS", `${button.offsetLeft}px`);
    this.tablist.style.setProperty("--widthJS", `${button.offsetWidth}px`);
  }

  bindEvents() { 

    document.addEventListener("click", (e) => { 
      let tabButton = e.target.closest(".tab-button");
      let loadMoreButton = e.target.closest(".load-more-button");

      if(tabButton) { 
        let currentTab = tabButton.closest(".tablist").querySelector("[aria-selected=true]");
        
        if (tabButton !== currentTab) {
            this.switchTab(currentTab, tabButton);
        }

      }

      if(loadMoreButton) { 
        this.loadMore(e.target);
      }

    });

    document.addEventListener("keydown", (e) => { 
      let tabButton = e.target.closest(".tab-button");

      if(tabButton) { 
        let currentTab = tabButton.closest(".tablist").querySelector("[aria-selected=true]");
        let newTab;

        if(e.key === "ArrowLeft" || e.key === "ArrowRight") { 
            e.preventDefault();

            if(e.key === "ArrowLeft") { 
                newTab = currentTab.previousElementSibling ? currentTab.previousElementSibling : currentTab.parentElement.lastElementChild;
            } else { 
                newTab = currentTab.nextElementSibling ? currentTab.nextElementSibling : currentTab.parentElement.firstElementChild;
            }

            this.switchTab(currentTab, newTab);
            newTab.focus();

        } else if(e.key === "ArrowDown") { 
            e.preventDefault();
            currentTab.focus();
        }
      }

    });

    // window.addEventListener("resize", function () {
    //   console.log(this.activeTabButton);
    //   this.doTablistCalculations(this.activeTabButton);
    // });

  }

  switchTab(currentTab, newTab) { 
      currentTab.setAttribute("aria-selected", "false");
      currentTab.setAttribute("tabindex", "-1");
      newTab.setAttribute("aria-selected", "true");
      newTab.setAttribute("tabindex", "0");


      if(this.querySelector(".sticky-tablist").classList.contains("is-sticky")) {
        let bodyRect = document.body.getBoundingClientRect(),
        elemRect = this.getBoundingClientRect(),
        offset   = elemRect.top - bodyRect.top;

        window.scrollTo({
          top: offset - 125,
          behavior: "smooth"
        });
      }
      
      this.doTablistCalculations(newTab);
      this.switchTabPanel(currentTab, newTab);
  }

  switchTabPanel(currentTab, newTab) { 
      let currentTabPanel = document.querySelector("#" + currentTab.getAttribute("aria-controls"));
      let newTabPanel = document.querySelector("#" + newTab.getAttribute("aria-controls"));

      currentTabPanel.classList.add("hidden");
      currentTabPanel.setAttribute("aria-hidden", "true");
      newTabPanel.classList.remove("hidden");
      newTabPanel.setAttribute("aria-hidden", "false");
  }

  getData() { 
    return fetch('/umbraco/delivery/api/v2/content/item/' + this.guid + '?fields=properties%5BblockList%5D')
      .then(response => response.json())
      .then(data => {
        this.data = data.properties.blockList.items;
      });
  }

  render() { 

    this.tabsContent = this.data.map((item, index) => {
      return {
        rows: item.content.properties.grid.items.length,
        content: item.content.properties.grid.items.map((gridItem, gridIndex) => { 
            
            // 12 columns - activity card
            if(gridItem.content.contentType == "blockGridComponentActivityCard" || gridItem.content.contentType == "blockGridComponentArticleCard") { 
              return {
                layout: "12 columns",
                content: this.renderFullwidth(gridItem.content),
              }
            }

            // 8/4 columns
            if(gridItem.content.contentType == "blockGridLayoutEightFourColumns") { 
              return {
                layout: "8/4 columns",
                content: this.renderAreas(gridItem.areas),
              }
            }

            // 4/8 columns
            if(gridItem.content.contentType == "blockGridLayoutFourEightColumns") { 
              return {
                layout: "4/8 columns",
                content: this.renderAreas(gridItem.areas),
              }
            }

            // 3 columns
            if(gridItem.content.contentType == "blockGridLayoutThreeColumns") { 
              return {
                layout: "3 columns",
                content: this.renderAreas(gridItem.areas),
              }
            }

          })
      };
    });

    this.renderTabPanelsHTML();
  }
 
  renderFullwidth(content) { 
    return `<div class="block-grid__layout-item flex-1">
              <div class="container">
                <div class="col-span-12 md:col-span-12 flex flex-col gap-6">${this.renderContent(content, 12)}</div>
              </div>
            </div>`;
  }

  renderAreas(areas) { 
    if(areas == null) return null;

    return `<div class="block-grid__layout-item flex-1">
              <div class="container">
                <div class="grid-layout">
                    ${areas.map(area => `
                    <div class="col-span-12 md:col-span-${area.columnSpan} flex flex-col gap-6">
                      ${area.items.map(item => this.renderContent(item.content, area.columnSpan)).join('')}
                    </div>
                  `).join('')}
                </div>
              </div>
            </div>`;
  }

  renderContent(content, columnSpan) { 

    if(content == null) return null;

    console.log("content", content);

    if(content.contentType == "blockGridComponentActivityCard" && columnSpan == 12) { 
      return `
            <div class="flex flex-col md:flex-row gap-6 bg-beige-600 p-4 rounded-small">
              ${content.properties.image != null && content.properties.image.length ? 
                `<picture class="shrink-0">
                      <source media="(min-width:768px)" srcset="${content.properties.image[0].url}?width=318&amp;height=398&amp;format=webp&amp;quality=85">
                      <img src="${content.properties.image[0].url}?width=640&amp;height=480&amp;format=webp&amp;quality=85" alt="" class="rounded-small w-full aspect-4/3 object-cover md:aspect-4/5">
                  </picture>` : ''
              }
            <div class="p-4">
              <h2 class="text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-grey mb-5 lg:mb-6">${content.properties.title}</h2>
              <div class="prose prose-lg">
                ${content.properties.text.markup}
              </div>
            </div>
        </div>
      `;
    } 

    if(content.contentType == "blockGridComponentActivityCard" && columnSpan != 12) { 
      return `
      <div class="block-grid__layout-item flex-1">
          <div class="flex flex-col sm:flex-row gap-6 bg-beige-600 p-4 rounded-small">
          ${content.properties.image != null && content.properties.image.length && columnSpan == 8 ? 
            `<picture class="shrink-0 sm:w-1/3 md:w-auto">
                <source media="(min-width:768px)" srcset="${content.properties.image[0].url}?width=218&amp;height=273&amp;format=webp&amp;quality=85">
                <img src="${content.properties.image[0].url}?width=640&amp;height=480&amp;format=webp&amp;quality=85" alt="" class="rounded-small w-full aspect-4/3 object-cover sm:aspect-4/5 sm:w-auto">
              </picture>` : ''
          }
          <div class="p-4">
            <h2 class="text-2xl md:text-3xl text-grey mb-5 lg:mb-6">${content.properties.title}</h2>
            <div class="prose prose-lg">
              ${content.properties.text.markup}
            </div>
          </div>
        </div>       
      </div>
      `;
    } 
    
    if(content.contentType == "blockGridComponentFactbox") { 
      return `
        <div class="block-grid__layout-item flex-1 flex">
          <div class="bg-blue text-white p-6 lg:p-8 rounded-small flex-1">
            <h2 class="text-2xl lg:text-3xl text-blue-100 mb-8">${content.properties.title}</h2>
            <div class="prose prose-lg text-white">
              ${content.properties.text.markup}
            </div>
          </div>
        </div>
      `;
    }

    if(content.contentType == "blockGridComponentArticleCard" && columnSpan == 12) { 
      return `
        <a href="${content.properties.link[0].linkType == "Content" ? content.properties.link[0].route.path : content.properties.link[0].url}" target="${content.properties.link[0].target}" class="image-zoom group flex flex-col md:flex-row gap-6 md:gap-8 bg-white p-4 rounded-small">
            ${content.properties.image != null && content.properties.image.length ? 
              `<figure class="rounded-small">
                  <picture class="shrink-0">
                    <source media="(min-width:768px)" srcset="${content.properties.image[0].url}?width=312&amp;height=390&amp;format=webp&amp;quality=85">
                    <img src="${content.properties.image[0].url}?width=640&amp;height=480&amp;format=webp&amp;quality=85" alt="" class="w-full aspect-4/3 object-cover">
                  </picture>
                </figure>` : ''
            }
            <div class="flex flex-col md:py-2">
              ${content.properties.tag != null ? 
                `<span class="tag self-start mb-4">${content.properties.tag[0].name}</span>` : ''
              }
              <h2 class="text-2xl md:text-3xl mb-4">${content.properties.title}</h2>
              <div class="prose prose-lg">
                ${content.properties.text}
              </div>
              <div class="mt-auto">
                  <div class="arrow-link">
                    <svg class="icon icon w-6 h-6" aria-hidden="true"><use href="/dist/svg/sprite.svg#arrow-right-circle"></use></svg>
                  </div>
              </div>
          </div>
        </a>
      `;
    } 

    if(content.contentType == "blockGridComponentArticleCard" && columnSpan == 8) { 
      return `
        <a href="${content.properties.link[0].linkType == "Content" ? content.properties.link[0].route.path : content.properties.link[0].url}" target="${content.properties.link[0].target}" class="image-zoom group flex flex-col sm:flex-row gap-6 md:gap-8 bg-white p-4 rounded-small">
            ${content.properties.image != null && content.properties.image.length ? 
              `<figure class="rounded-small self-start">
                  <picture class="shrink-0 sm:w-1/3 md:w-auto">
                    <source media="(min-width:768px)" srcset="${content.properties.image[0].url}?width=312&amp;height=390&amp;format=webp&amp;quality=85">
                    <img src="${content.properties.image[0].url}?width=640&amp;height=480&amp;format=webp&amp;quality=85" alt="" class="w-full aspect-4/3 object-cover sm:aspect-4/5 sm:w-auto">
                  </picture>
                </figure>` : ''
            }
            <div class="flex-1 flex flex-col md:py-2">
              ${content.properties.tag != null ? 
                `<span class="tag self-start mb-4">${content.properties.tag[0].name}</span>` : ''
              }
              <h2 class="text-2xl mb-5 lg:mb-6">${content.properties.title}</h2>
              <div class="prose prose-lg">
                ${content.properties.text}
              </div>
              <div class="mt-auto">
                  <div class="arrow-link">
                    <svg class="icon icon w-6 h-6" aria-hidden="true"><use href="/dist/svg/sprite.svg#arrow-right-circle"></use></svg>
                  </div>
              </div>
          </div>
        </a>
      `;
    } 

    if(content.contentType == "blockGridComponentArticleCard" && columnSpan == 4) { 
      return `
        <a href="${content.properties.link[0].linkType == "Content" ? content.properties.link[0].route.path : content.properties.link[0].url}" target="${content.properties.link[0].target}" class="image-zoom group flex-1 flex flex-col gap-6 bg-white p-4 rounded-small">
            ${content.properties.image != null && content.properties.image.length ? 
              `<figure class="rounded-small self-start">
                  <picture class="shrink-0">
                    <source media="(min-width:768px)" srcset="${content.properties.image[0].url}?width=330&amp;height=186&amp;format=webp&amp;quality=85">
                    <img src="${content.properties.image[0].url}?width=640&amp;height=480&amp;format=webp&amp;quality=85" alt="" class="w-full aspect-4/3 object-cover sm:aspect-video">
                  </picture>
                </figure>` : ''
            }
            <div class="flex-1 flex flex-col">
              ${content.properties.tag != null ? 
                `<span class="tag self-start mb-4">${content.properties.tag[0].name}</span>` : ''
              }
              <h2 class="text-2xl md:text-xl mb-2">${content.properties.title}</h2>
              <div class="prose">
                ${content.properties.text}
              </div>
              <div class="mt-auto">
                  <div class="arrow-link">
                    <svg class="icon icon w-6 h-6" aria-hidden="true"><use href="/dist/svg/sprite.svg#arrow-right-circle"></use></svg>
                  </div>
              </div>
          </div>
        </a>
      `;
    } 


  }

  renderTabPanelsHTML() {
    let that = this;
    
    this.tabsPanels.forEach((tabPanel, index) => {
      let totalRows = this.tabsContent[index].rows;
      let skip = 0;
      let take = that.tabPanelRows;

      if (totalRows < skip + take) {
        take = totalRows - skip;
      }      

      let tabPanelContent = this.tabsContent[index].content
      .slice(skip, take)
      .map((item, index) => {
          if(item == undefined ) return null;
          return `${item.content}`;
        });

      if(totalRows > skip + take) {
        tabPanelContent.push(`<div class="container flex justify-center my-8 lg:my-12"><button class="button load-more-button" data-index="${index}" data-skip="${skip + take}" data-take="${take}" data-total="${totalRows}">Vis flere aktiviteter</button></div>`);
      }

      tabPanel.innerHTML = tabPanelContent.join("");
    });

  }

  loadMore(button) { 
    let index = parseInt(button.dataset.index);
    let skip = parseInt(button.dataset.skip);
    let take = parseInt(button.dataset.take);
    let totalRows = parseInt(button.dataset.total);

    button.parentElement.remove();

    let tabPanelContent = this.tabsContent[index].content
      .slice(skip, skip + take)
      .map((item, index) => {
          return `${item.content}`;
        });


    if(totalRows > skip + take) {
      tabPanelContent.push(`<div class="container flex justify-center my-8 lg:my-12"><button class="button load-more-button" data-index="${index}" data-skip="${skip + take}" data-take="${take}" data-total="${totalRows}">Vis flere aktiviteter</button></div>`);
    }

    this.tabsPanels[index].insertAdjacentHTML(
        'beforeend', 
        tabPanelContent.join("")
    )

  }

}

customElements.define('nabohjaelp-activity-tabs', ActivityTabs);